import React, { useEffect, useState } from "react";
import PasswordInput from "component/common/PasswordInput";
import ErrorMessage from "component/common/ErrroMessage/index";
import { useForm } from "react-hook-form";
import { useHistory, useLocation } from "react-router-dom";
import { Toast } from "utils/toast";
import { changePassword } from "service/Auth";

import styles from "./ForgotPassword.module.scss";

const ForgotPasswordComp = () => {
  const history = useHistory();

  const location = useLocation();

  const {
    register,
    getValues,
    reset,
    formState: { errors },
    handleSubmit,
  } = useForm();

  let token = new URLSearchParams(location.search).get("token");


  useEffect(() => {
    let token = new URLSearchParams(location.search).get("token");
    let tokenCheck = JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString());
    console.log(tokenCheck._id, ' jwt-token-->')
  }, []);

  const onSubmit = async (data,) => {
    let tokenCheck = JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString());
    let id = tokenCheck._id;
    let body = {
      oldPassword: tokenCheck.password,
      newPassword: data.newPassword,
      confirmPassword: data.confirmPassword,

    };

    try {
      let response = await changePassword(id, body, token);
      if (response.status == 200) {
        reset({
          newPassword: "",
          confirmPassword: "",
        });
        Toast({
          type: "success",
          message: "Password has been changed successfully",
        });
        history.push("/");
      }
    } catch (error) {
      Toast({ type: "error", message: error.data.message });
    }
  };

  return (
    <div className={styles.forgot_password}>
      <div className={styles.forgot_title}>
        <b>CHANGE PASSWORD</b>
      </div>
      {/* <div className={styles.forgot_field_confirm}>
        <PasswordInput
          label="Old Password"
          register={register("oldPassword", {
            required: true,
            validate: () =>
              getValues("oldPassword") !== getValues("newPassword"),
          })}
          error={errors.confirmPassword}
        />
        <ErrorMessage
          error={errors.confirmPassword}
          message={{
            required: "Please enter new password",
            validate: "Old and New Password should not be same",
          }}
        />
      </div> */}
      <div className={styles.forgot_field}>
        <PasswordInput
          label="New Password"
          register={register("newPassword", {
            required: true,
            pattern:
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#@$!%*?&])[A-Za-z\d@$#!%*?&]{8,}$/,
          })}
          error={errors.newPassword}
        />
        <ErrorMessage
          error={errors.newPassword}
          message={{
            required: "Please enter new password",
          }}
        />
        {errors.newPassword?.type !== "required" && (
          <div
            className={styles.password_note}
            style={{ color: errors.newPassword ? "red" : "green" }}
          >
            <i className="bi bi-exclamation-circle"></i>
            <span>
              Password contains atleast 8 character includes one captial letter,
              symbol, number
            </span>
          </div>
        )}
      </div>
      <div className={styles.forgot_field_confirm}>
        <PasswordInput
          label="Confrim Password"
          register={register("confirmPassword", {
            required: true,
            validate: () =>
              getValues("newPassword") === getValues("confirmPassword"),
          })}
          error={errors.confirmPassword}
        />
        <ErrorMessage
          error={errors.confirmPassword}
          message={{
            required: "Please enter confirm password",
            validate: "Confirm password is not match with New Password",
          }}
        />
      </div>
      <div className={styles.back_login_change}>
        <span onClick={() => history.push("/")}> Back to Sign In</span>
      </div>
      <div className={styles.btn_forgot}>
        <button onClick={handleSubmit(onSubmit)}>SUBMIT</button>
      </div>
    </div>
  );
};

export default ForgotPasswordComp;
